import { jsx as _jsx } from "react/jsx-runtime";
import React, { lazy, Suspense, useMemo } from 'react';
import { CircularLoader } from 'seagull/components/CircularLoader';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { PdfViewerTestIds } from './PdfViewer.utils';
const PdfLazyLoader = /*#__PURE__*/ lazy(()=>import('./inner/PdfViewerInner').then((module)=>({
            default: module.PdfViewerInner
        })));
export const PdfViewer = (param)=>{
    let { getFileUrl, singlePageStyle, hideSinglePageLoader, style, pdfUniqueName } = param;
    const { data: url } = useQueryState({
        queryKey: [
            QueryKeys.PdfUrl,
            pdfUniqueName
        ],
        queryFn: ()=>getFileUrl(pdfUniqueName),
        enabled: !!pdfUniqueName
    });
    const loader = useMemo(()=>/*#__PURE__*/ _jsx("div", {
            "data-testid": PdfViewerTestIds.loader(),
            style: {
                position: 'absolute',
                top: 'calc(50% - 16px)',
                left: 'calc(50% - 16px)'
            },
            children: /*#__PURE__*/ _jsx(CircularLoader, {
                size: 32
            })
        }), []);
    if (!url) return loader;
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: loader,
        children: /*#__PURE__*/ _jsx(PdfLazyLoader, {
            singlePageStyle: singlePageStyle,
            hideSinglePageLoader: hideSinglePageLoader,
            style: style,
            loader: loader,
            url: url
        })
    });
};
